<template>
  <v-list nav dense class="px-9 py-7">
    <h2 class="dark--text font-weight-semibold text-xl">APPLICATIONS</h2>
    <v-divider class="mediumGrey mt-3"></v-divider>
    <div class="grid mt-6">
      <div
        v-for="(app, index) in launcherApps.purchasedBaseApps"
        :key="index"
        :data-cy="app.value"
        class="child text-center py-4 px-2 cursor-pointer"
        @click="gotoApp(app)"
      >
        <v-img :src="app.icon" width="40px" class="mx-auto" height="40px"></v-img>
        <p class="dark--text mb-0 mt-3 text-sm">{{ app.title }}</p>
      </div>
    </div>

    <h2 class="dark--text mt-5 font-weight-semibold text-xl">MANAGEMENT APPLICATIONS</h2>
    <v-divider class="mediumGrey mt-3"></v-divider>

    <div class="grid mt-5">
      <div
        v-for="(app, index) in launcherApps.purchasedManagementApps"
        :key="index"
        class="child text-center py-4 px-2 cursor-pointer"
        @click="gotoApp(app)"
      >
        <div class="justify-self-center">
          <v-img :src="app.icon" width="40px" class="mx-auto"></v-img>
          <p class="dark--text mb-0 mt-3 text-sm">{{ app.title }}</p>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="pa-5 font-weight-normal text-wrap">
          Unlock the Manufacturing Module for just $300/month
        </v-card-title>

        <v-card-subtitle class="text-center pa-5">
          Are you sure you want to continue
        </v-card-subtitle>

        <v-card-actions class="justify-end pa-4">
          <v-btn color="primary" @click="confirmExit" :loading="loading">YES</v-btn>
          <v-btn color="#e3dddd" @click="dialog = false">NO</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list>
</template>
<script>
import CrmSvg from '@/assets/images/svg/CRM.svg'
import Estimation from '@/assets/images/svg/Estimation.svg'
import Security from '@/assets/images/svg/Security.svg'
import Setup from '@/assets/images/svg/Setup.svg'
import workDrive from '@/assets/images/svg/workDrive.svg'
import { mdiClose } from '@mdi/js'
import { useRouter } from '@core/utils'
import store from '@/store'
import { storeActions, storeGetters } from '@/store/storeConstants'
import { computed, ref } from '@vue/composition-api'
import Toaster from '@core/utils/sweetToast'

const { GET_LAUNCHER_APP, GET_CUSTOMER_SUBSCRIPTION } = storeGetters
export default {
  setup(_, { emit }) {
    const { ESTIMATE_TAB_REQUEST, SETUP_TAB_REQUEST, REPORT_TAB_REQUEST, DASHBOARD_TAB_REQUEST } =
      storeActions
    const { router } = useRouter()
    const dialog = ref(false)
    const loading = ref(false)
    const subscriptionMode = computed(() => localStorage.getItem('subscriptionMode'))

    const gotoApp = item => {
      if (item.title === 'Customer') {
        store.dispatch('tabPersist/SET_TAB_STATE', { attribute: 'Select' })
      }
      if (item.title === 'Retail Vendor') {
        store.dispatch('tabPersist/SET_TAB_STATE', { attribute: 'Select' })
      }
      if (item.title === 'CRM') {
        store.dispatch('tabPersist/SET_TAB_STATE', { attribute: 'CRM Dashboard' })
      }
      if (item.title === 'Estimation') {
        store.dispatch(`setupTab/${ESTIMATE_TAB_REQUEST}`, { attribute: 'Estimation Projects' })
      }
      if (item.title === 'Setup') {
        store.dispatch(`setupTab/${SETUP_TAB_REQUEST}`, { attribute: 'CRM' })
      }
      if (item.title === 'Reports') {
        store.dispatch(`setupTab/${REPORT_TAB_REQUEST}`, { attribute: 'Reports' })
      }
      if (item.title === 'Dashboard') {
        store.dispatch(`setupTab/${DASHBOARD_TAB_REQUEST}`, { attribute: 'Dashboards' })
      }
      if (item.title === 'Vendor Management') {
        store.dispatch('tabPersist/SET_TAB_STATE', { attribute: 'Vendors' })
      }

      const isBuyManufacturingModule = store.getters['signup/GET_IS_BUY_MANUFACTURING_MODULE']

      if (
        item.to.name === 'work-center-overview' &&
        isBuyManufacturingModule === true &&
        subscriptionMode.value === 'online'
      ) {
        dialog.value = true
        // if (router.currentRoute.name != 'user-dashboard') {
        //   router.push({ name: 'user-dashboard' })
        // }
        return
      }
      // else{
      //   Toaster.error('Your trial has Expired!')
      // }
      restrictModules(item)
      router.push(item.to).catch(() => {})
      emit('close')
    }

    const launcherApps = computed(() => store.getters[`auth/${GET_LAUNCHER_APP}`])

    const fetchApps = () => {
      const { purchasedBaseApps, purchasedManagementApps } = launcherApps.value
      if (purchasedBaseApps.length || purchasedManagementApps.length) return

      store.dispatch(`auth/${storeActions.FETCH_APPS}`)
    }

    fetchApps()

    const customerSubscription = computed(
      () => store.getters[`signup/${GET_CUSTOMER_SUBSCRIPTION}`],
    )

    const fetchCustomerSubscriptions = () => {
      if (Object.keys(customerSubscription.value).length) return
      store.dispatch(`signup/${storeActions.FETCH_CUSTOMER_SUBSCRIPTION}`)
    }

    fetchCustomerSubscriptions()

    const confirmExit = () => {
      buyManufacturingModule()
    }

    const buyManufacturingModule = async () => {
      loading.value = true
      try {
        const response = await store.dispatch('signup/BUY_MANUFACTURING_MODULE')
        if (response.success) {
          loading.value = false
          dialog.value = false
          router.push({ name: 'user-dashboard' })
          Toaster.success('Successfully purchased manufacturing module.', 'success')
          window.location.reload()
        }
      } catch (error) {
        loading.value = false
        dialog.value = false
        Toaster.error('An eror occur, please try again later', 'warning')
      }
    }

    const restrictModules = item => {
      const restrictedModules = [
        'Customer',
        'Retail Vendor',
        'CRM',
        'Estimation',
        'Setup',
        'Reports',
        'Dashboard',
        'Vendor Management',
        'Email',
        'Work Drive',
        'Task Management',
        'Material Management',
        'Project Management',
        'Accounting',
        'Inventory Management',
        'Field Management',
        'Manufacturing',
        'Form Builder',
      ]

      if (router.currentRoute.name != 'user-dashboard' && restrictedModules.includes(item.title)) {
        router.push({ name: 'user-dashboard' })
      }
    }

    return {
      // purchasedBaseApps,
      // purchasedManagementApps,
      dialog,
      loading,
      subscriptionMode,
      gotoApp,
      confirmExit,
      restrictModules,
      // icons
      CrmSvg,
      launcherApps,
      Estimation,
      Security,
      Setup,
      workDrive,
      mdiClose,
    }
  },
}
</script>
<style scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px;
  align-items: center;
  /* grid-template-rows: repeat(3, calc(100%/3)); */
}

.child {
  border: 1px solid #f8ebe7;
  box-shadow: 0px 14px 18px rgba(225, 119, 89, 0.09);
  border-radius: 10px;
  height: 100%;
}
</style>
